import * as React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import "./utils/translations";
import configureStore from "./store";
import rootSaga from "./sagas";
import AppContainer from "./containers/AppContainer";
import Beforeunload from "react-beforeunload";

const { store, persistor } = configureStore();
store.runSaga(rootSaga, store);

const root = document.getElementById("root");
render(
  <Beforeunload
    onBeforeunload={() => {
      persistor.purge();
    }}
  >
    <Provider store={store}>
      <AppContainer />
    </Provider>
  </Beforeunload>,
  root
);



// WEBPACK FOOTER //
// ./src/index.js